module.exports = __webpack_public_path__ + "images/header_left_2a-84024b1b4e.png";